export const JSON_ARRAY_FIELDS = ['MLSPhotoFolder'];

const parseJsonArrayValue = (val) => {
  if (val == null || val === '') return [];
  if (Array.isArray(val)) return val;
  if (typeof val === 'string') {
    try {
      const parsed = JSON.parse(val);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
  return [];
};

export const parseJsonArrayFields = (sheet) => {
  if (!sheet) return sheet;
  JSON_ARRAY_FIELDS.forEach((field) => {
    if (!Array.isArray(sheet[field])) return;
    sheet[field] = sheet[field].map(parseJsonArrayValue);
  });
  return sheet;
};
